var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-1"}),_c('div',{staticClass:"loading-2"}),_c('div',{staticClass:"loading-3"}),_c('div',{staticClass:"loading-4"})])
}]

export { render, staticRenderFns }